export const NATURAL_FEATURE_OPTIONS = [
  { key: "hasTree", label: "Trees" },
  { key: "hasWater", label: "Water bodies" },
  { key: "hasForest", label: "Forests" },
  { key: "hasLake", label: "Lakes" },
  { key: "hasRiver", label: "Rivers" },
  { key: "hasSea", label: "Sea" }
];

export const NATURAL_FEATURE_LABELS = NATURAL_FEATURE_OPTIONS.reduce(
  (acc, feature) => {
    acc[feature.key] = feature.label;
    return acc;
  },
  {}
);

export const createDefaultFilters = () => ({
  bothyFeatures: [],
  naturalFeatures: NATURAL_FEATURE_OPTIONS.reduce(
    (acc, { key }) => {
      acc[key] = false;
      return acc;
    },
    {}
  ),
  elevation: {
    min: "",
    max: ""
  },
  bortleClass: "",
  roadDistance: {
    min: "",
    max: ""
  },
  weather: {
    maxPrecipitation: "",
    maxRainfall: "",
    maxSnowfall: "",
    minSnowDepth: "",
    maxWindSpeed: "",
    maxPrecipitationHours: "",
    minDailyLow: "",
    maxDailyHigh: "",
    minSnowfall: "",
    targetDayIndex: ""
  }
});
